import { DeleteFromWishlistDetailsDto } from './deletefromwishlistdetailsdto';

export interface DeleteFromWishlistDto
{
    getIdentifier(): string;
    getMsisdn(): string;
    getWishlistType(): string;
    getLanguage(): string;
    getCatagoryId(): string;

    getDescription():string;
    getDeletionStatusList():DeleteFromWishlistDetailsDto[];
}

export class DeleteFromWishlistDtoImpl implements DeleteFromWishlistDto
{
    private identifier: string;
    private msisdn: string;
    private wishlistType: string;
    private language: string;
    private catagoryId: string;
    private description: string;
    private deletionStatusList: DeleteFromWishlistDetailsDto[];

    getIdentifier(): string 
    {
        return this.identifier;
    }
    setIdentifier(identifier: string)
    {
        this.identifier = identifier;
    }

    getMsisdn(): string 
    {
        return this.msisdn;
    }
    setMsisdn(msisdn: string)
    {
        this.msisdn = msisdn;
    }

    getCatagoryId(): string 
    {
        return this.catagoryId;
    }
    setCatagoryId(catagoryId: string)
    {
        this.catagoryId = catagoryId;
    }

    getLanguage(): string 
    {
        return this.language;
    }
    setLanguage(language: string)
    {
        this.language = language;
    }

    getWishlistType(): string 
    {
        return this.wishlistType;
    }
    setWishlistType(wishlistType: string)
    {
        this.wishlistType = wishlistType;
    }

    getDescription(): string 
    {
        return this.description;
    }
    setDescription(description: string)
    {
        this.description = description;
    }

    getDeletionStatusList(): DeleteFromWishlistDetailsDto[] 
    {
        return this.deletionStatusList;
    }
    setDeletionStatusList(deletionStatusList: DeleteFromWishlistDetailsDto[])
    {
        this.deletionStatusList = deletionStatusList;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/wishlist/deletefromwishlist/deletefromwishlistdto.tsx